import {
  useMenusDataGrid,
  useMenusInitialState,
  useMenusToolbar,
} from './menus-data-grid.hooks';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import { MenuResult } from 'api/ordering-service/ordering-service.types';
import MenusDetailsDrawer from '../../menus-details-drawer/menus-details-drawer.component';
import MenuDeleteDrawer from '../../menu-delete-drawer/menu-delete-drawer.component';
import MenusDeleteDrawer from '../../menus-delete-drawer/menus-delete-drawer.component';
import MenuManagementBulkEditDataGrid from 'pages/menu-management/menu-management-bulk-edit-data-grid/menu-management-bulk-edit-data-grid.component';

type MenusDataGridProps = {
  isNative?: boolean;
};

const MenusDataGrid = ({ isNative = false }: MenusDataGridProps) => {
  const menusDetailsDrawer = useUtilityDrawer<MenuResult>();
  const deleteConfirmationDrawer = useUtilityDrawer<MenuResult>();
  const bulkDeleteConfirmationDrawer = useUtilityDrawer<MenuResult>();

  const columns = useMenusDataGrid(isNative, deleteConfirmationDrawer);
  const toolbar = useMenusToolbar(isNative, bulkDeleteConfirmationDrawer);
  const initialState = useMenusInitialState();

  const handleRowClick = params => {
    menusDetailsDrawer.setDrawerData(params);
    menusDetailsDrawer.setOpen(true);
  };

  return (
    <>
      <MenuManagementBulkEditDataGrid
        columns={columns}
        data-testid={isNative ? 'MenusNativeDataGrid' : 'MenusImportedDataGrid'}
        onRowClick={params => handleRowClick(params)}
        getRowId={(row: MenuResult) => row?.catalogId}
        toolbar={toolbar}
        initialState={initialState}
      />
      <MenusDetailsDrawer {...menusDetailsDrawer} />
      <MenuDeleteDrawer {...deleteConfirmationDrawer} />
      <MenusDeleteDrawer {...bulkDeleteConfirmationDrawer} />
    </>
  );
};

export default MenusDataGrid;
